/* We utilize the Store URL to avoid creating an unnecessary parameter simply for retrieving a teamId for the instant-exchange-disclaimer.
  Since access to the team settings already provides a Store URL, this approach ensures more efficient and streamlined data access. */
const LANE_201 = "lane-201.myshopify.com";

export enum TeamCustomLayout {
  LANE_201 = "lane-201.myshopify.com",
}

const teamIdToTeamCustomLayout = new Map([
  [LANE_201, TeamCustomLayout.LANE_201],
]);

export const getTeamCustomLayout = (
  teamId: string,
): TeamCustomLayout | undefined => {
  return teamIdToTeamCustomLayout.get(teamId);
};
